import React from 'react'
import PropTypes from 'prop-types'
import { Listbox } from '@headlessui/react'
import { Link } from 'gatsby'

import ProfileMenu from './profileMenu'
import { useTimezoneService } from 'theme/services/timezoneService'

import { getTimezones } from 'theme/utils/timezone-helpers'
import { formatMins } from 'theme/utils/generic-helpers'
import { ArrowLeftIcon } from '@heroicons/react/solid'

export const MainMenu = () => {
  // const { conferences } = useStaticQuery(query)

  // const selectedConference = conference && conference.data && conference.data.Conference_Id

  const timezoneService = useTimezoneService()
  const timezoneList = getTimezones()

  // const filteredConferences = conferences.nodes.filter((conf) => {
  //   return conf.data.Type === 'Conference'
  // })

  // const sortedConferences = filteredConferences.sort((a, b) => {
  //   if (a.data.Conference_Name > b.data.Conference_Name) return 1
  //   if (a.data.Conference_Name < b.data.Conference_Name) return -1
  // })

  return (
    <div className="h-10 bg-gray-700 text-gray-200">
      <div className="max-w-7xl flex mx-auto pt-2 justify-between px-4 sm:px-6 lg:px-8">
        <div className="flex">
          <Link
            to="/"
            activeClassName="font-bold text-white"
            className="hover:text-white px-2 mr-4 pb-1 hidden lg:flex"
          >
            UXDX.com
          </Link>
          <Link
            to="/conferences"
            activeClassName="font-bold text-white"
            className="hidden sm:flex mr-4 md:mr-6 lg:mr-8 pb-1 items-center text-md leading-5 text-gray-100 focus:outline-none focus:ring-white"
          >
            &nbsp;Conferences
          </Link>
          <Link
            to="/"
            activeClassName="font-bold text-white"
            className="flex sm:hidden mr-4 md:mr-6 lg:mr-8 pb-1 items-center text-md leading-5 text-gray-100 focus:outline-none focus:ring-white"
          >
            <span className="flex sm:hidden content-center items-center">
              <ArrowLeftIcon className="h-4 w-4 mr-2" /> More{' '}
            </span>
            &nbsp;Conferences
          </Link>
          <a
            href="https://zeroblockers.com/courses"
            activeClassName="font-bold text-white"
            className="hidden sm:flex mr-4 md:mr-6 lg:mr-8 pb-1 items-center text-md leading-5 text-gray-100 focus:outline-none focus:ring-white"
          >
            Training
          </a>
          <Link
            to="/model"
            activeClassName="font-bold text-white"
            className="hidden lg:flex mr-4 md:mr-6 lg:mr-8 pb-1 items-center text-md leading-5 text-gray-100 focus:outline-none focus:ring-white"
          >
            Model
          </Link>
          <Link
            to="/community"
            activeClassName="font-bold text-white"
            className="hidden lg:flex mr-4 md:mr-6 lg:mr-8 pb-1 items-center text-md leading-5 text-gray-100 focus:outline-none focus:ring-white"
          >
            Community
          </Link>
          <Link
            to="/jobs"
            activeClassName="font-bold text-white"
            className="hidden lg:flex mr-4 md:mr-6 lg:mr-8 pb-1 items-center text-md leading-5 text-gray-100 focus:outline-none focus:ring-white"
          >
            Jobs
          </Link>
        </div>

        <div className="ml-2 justify-end sm:w-64 lg:w-1/3 flex">
          <div className="sm:flex-col hidden max-w-64 mt-1 flex">
            <Listbox value={timezoneService.timezone} onChange={(e) => timezoneService.saveTimezone(e)}>
              <Listbox.Button
                id={`timezone-button`}
                data-cy="timezone-button"
                className="flex justify-end items-center focus:outline-none active:outline-none text-sm truncate"
              >
                <span className="font-bold ">
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </span>
                <span className="truncate max-w-20">{timezoneService.timezone}</span>
                <svg className="w-5 h-5 ml-1 -mr-1" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </Listbox.Button>
              <Listbox.Options
                data-cy="timezone-options-list"
                className="bg-white border-0 mt-2 text-black z-50 h-64 w-64 overflow-auto rounded-md shadow-lg focus:outline-none active:outline-none"
              >
                {({ active, selected }) =>
                  timezoneList.map((timezone) => (
                    <Listbox.Option
                      key={timezone.name}
                      value={timezone.name}
                      className={`${
                        selected || active
                          ? 'bg-gray-700 text-gray-100'
                          : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                      } block px-4 py-2 text-sm leading-5  focus:outline-none focus:bg-gray-700 focus:text-gray-100`}
                    >
                      {timezone.name} (GMT
                      {timezone.rawOffsetInMinutes > 0 ? '+' : '-'}
                      {formatMins(timezone.rawOffsetInMinutes, 'absolute')})
                    </Listbox.Option>
                  ))
                }
              </Listbox.Options>
            </Listbox>
          </div>

          <ProfileMenu />
        </div>
      </div>
    </div>
  )
}

MainMenu.propTypes = {
  conference: PropTypes.shape({
    data: PropTypes.shape({
      Conference_Id: PropTypes.string,
    }),
  }),
}
